module.exports = __webpack_public_path__ + "img/icon_delete.00a4c9e3.svg";